var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "start-page-fund-search ci-card" }, [
    _c("h2", {
      staticClass: "h2",
      domProps: {
        textContent: _vm._s(_vm.$t("ui.components.start.fund_search.title")),
      },
    }),
    _vm._v(" "),
    _c("p", {
      staticClass: "text-muted",
      domProps: {
        textContent: _vm._s(
          _vm.$t("ui.components.start.fund_search.description")
        ),
      },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex flex-column flex-md-row" }, [
      _c("div", { staticClass: "flex-grow-1" }, [
        _c("div", { staticClass: "ci-form--wrapper" }, [
          _c(
            "div",
            {
              staticClass: "ci-form--group has-leading-icon",
              class: { populated: _setup.searchTerm.length > 0 },
            },
            [
              _c("span", {
                staticClass:
                  "ci-form--leading-icon flex-center mdi mdi-magnify",
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _setup.searchTerm,
                    expression: "searchTerm",
                  },
                ],
                staticClass: "ci-form--input searchTerm",
                attrs: { name: "searchTerm", type: "text" },
                domProps: { value: _setup.searchTerm },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _setup.searchTerm = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c("label", {
                staticClass: "ci-form--label",
                attrs: { for: "searchTerm" },
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("ui.components.start.fund_search.search.placeholder")
                  ),
                },
              }),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-2 mt-md-0 ml-md-3" },
        [
          _c(_setup.CiButton, {
            staticClass: "w-100 h-100 px-3 py-2",
            attrs: {
              label: _vm.$t("ui.components.start.fund_search.search.button"),
              variant: "filled-primary",
            },
            on: { click: _setup.search },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }